import { gql } from '@apollo/client';

// Video Conference Fragment for reuse
export const VIDEO_CONFERENCE_FIELDS = gql`
  fragment VideoConferenceFields on VideoConference {
    id
    title
    description
    status
    scheduledStartTime
    scheduledEndTime
    actualStartTime
    actualEndTime
    duration
    hostId
    host {
      id
      firstName
      lastName
      email
    }
    clientId
    client {
      id
      firstName
      lastName
      email
    }
    inquiryId
    inquiry {
      id
      firstName
      lastName
      email
    }
    caseId
    guestName
    guestEmail
    guestPhone
    joinUrl
    isRecordingEnabled
    recordingStatus
    attendeeIds
    attendees {
      id
      firstName
      lastName
    }
    participants {
      id
      type
      referenceId
      name
      email
      phone
      notifyEmail
      notifyPush
      notifySms
    }
    waitingRoomEnabled
    waitingRoomParticipants {
      id
      name
      participantType
      requestedAt
    }
    reminderTimes
    muteAllEnabled
    preventUnmuteEnabled
    createdAt
    updatedAt
  }
`;

// Waiting Room Mutations
export const ADMIT_PARTICIPANT = gql`
  mutation AdmitParticipant($conferenceId: ID!, $participantId: ID!) {
    admitParticipant(conferenceId: $conferenceId, participantId: $participantId) {
      id
      waitingRoomParticipants {
        id
        name
        participantType
        requestedAt
      }
    }
  }
`;

export const DENY_PARTICIPANT = gql`
  mutation DenyParticipant($conferenceId: ID!, $participantId: ID!) {
    denyParticipant(conferenceId: $conferenceId, participantId: $participantId) {
      id
      waitingRoomParticipants {
        id
        name
        participantType
        requestedAt
      }
    }
  }
`;

export const ADMIT_ALL_PARTICIPANTS = gql`
  mutation AdmitAllParticipants($conferenceId: ID!) {
    admitAllParticipants(conferenceId: $conferenceId) {
      id
      waitingRoomParticipants {
        id
        name
        participantType
        requestedAt
      }
    }
  }
`;

export const TOGGLE_WAITING_ROOM = gql`
  mutation ToggleWaitingRoom($conferenceId: ID!, $enabled: Boolean!) {
    toggleWaitingRoom(conferenceId: $conferenceId, enabled: $enabled) {
      id
      waitingRoomEnabled
    }
  }
`;

// Host Control Mutations
export const ADD_PARTICIPANT_DURING_CALL = gql`
  mutation AddParticipantDuringCall($conferenceId: ID!, $participant: ParticipantInput!) {
    addParticipantDuringCall(conferenceId: $conferenceId, participant: $participant) {
      id
      participants {
        id
        type
        referenceId
        name
        email
        phone
        notifyEmail
        notifyPush
        notifySms
      }
    }
  }
`;

export const MUTE_ALL_PARTICIPANTS = gql`
  mutation MuteAllParticipants($conferenceId: ID!, $preventUnmute: Boolean) {
    muteAllParticipants(conferenceId: $conferenceId, preventUnmute: $preventUnmute) {
      id
      muteAllEnabled
      preventUnmuteEnabled
    }
  }
`;

export const UNMUTE_ALL_PARTICIPANTS = gql`
  mutation UnmuteAllParticipants($conferenceId: ID!) {
    unmuteAllParticipants(conferenceId: $conferenceId) {
      id
      muteAllEnabled
      preventUnmuteEnabled
    }
  }
`;

// Chat Mutations
export const SAVE_CHAT_MESSAGE = gql`
  mutation SaveChatMessage($conferenceId: ID!, $message: ChatMessageInput!) {
    saveChatMessage(conferenceId: $conferenceId, message: $message) {
      id
      conferenceId
      senderId
      senderName
      content
      timestamp
    }
  }
`;

// Chat Queries
export const GET_CONFERENCE_CHAT_HISTORY = gql`
  query GetConferenceChatHistory($conferenceId: ID!) {
    getConferenceChatHistory(conferenceId: $conferenceId) {
      items {
        id
        conferenceId
        senderId
        senderName
        content
        timestamp
      }
      nextToken
    }
  }
`;

// Waiting Room Subscription
export const ON_WAITING_ROOM_UPDATED = gql`
  subscription OnWaitingRoomUpdated($conferenceId: ID!) {
    onWaitingRoomUpdated(conferenceId: $conferenceId) {
      id
      waitingRoomParticipants {
        id
        name
        participantType
        requestedAt
      }
    }
  }
`;
